export default __webpack_public_path__ + "static/media/dayclinic.7e4947ca.svg";